/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, CircularProgress, Skeleton } from "@mui/material";
import { SAMLService } from "../../../services/samlService";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { OTP_TIMEOUT } from "../../../config/appConfig";
import { concatMap, interval, Subject, takeUntil } from "rxjs";
import NafathLogo from '../../../assets/images/Nafath_logo.svg';
import { TextWrapper } from "../formUtilities/useTextWrapper";
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import { ButtonWrapper } from "../formUtilities/useButton";
import { SectionWithHeading } from "../common/sectionWithHeading";
import { InvestorService } from "../../../pages/investor/investorService";
import { saveTokenFromRegistration, serverNowFrom } from "../../../services/authService";
import {
  NAFATH_TRANSACTION_TIMEOUT_SECONDS,
  NafathFailure,
  nafathFailureFrom,
  nafathMessageKey,
  nafathResendLockSeconds,
} from "../../../helpers/nafathHelper";

export const UserNafathVerification = ({ showMainSection = true, onSuccess = null }) => {
  const samlService = new SAMLService();
  const investorService = new InvestorService();
  const { t } = useTranslation();
  const [resendCounter, setResendCounter] = useState(0);
  const [authNumber, setAuthNumber] = useState(null);
  const [loading, setLoading] = useState(false);
  const [investorDetails, setInvestorDetails] = useState(false);
  const [isSuccessNafath, setIsSuccessNafath] = useState(false);
  const [loadingNafath, setLoadingNafath] = useState(false);
  const [stopTimer, setStopTimer] = useState(false);
  const [nafathFailure, setNafathFailure] = useState(null);
  const counter = OTP_TIMEOUT;

  useEffect(() => {
    getInvestorDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkIfNafathCompleted = () => {
    samlService.isUserVerified().then(resp => {
      let response = resp.data;
      saveTokenFromRegistration(response?.loginModel, serverNowFrom(resp));
      if (response?.isNafathCompleted) {
        setIsSuccessNafath(true);
        setLoading(false);
        success();
      } else {
        setIsSuccessNafath(false);
        getSAMLNumber();
      }
    }).catch(err => {
      setLoading(false);
    });
  };

  const getInvestorDetails = () => {
    setLoading(true);
    investorService.getInvestor().then(resp => {
      setInvestorDetails(resp.data);
    }).catch(err => { setLoading(false); });
  };

  useEffect(() => {
    if (investorDetails) {
      if (investorDetails?.nationalId) {
        setTimeout(() => {
          checkIfNafathCompleted();
        }, 1000);
      } else {
        setLoading(false);
      }
    }
  }, [investorDetails]);

  useEffect(() => {
    resendCounter > 0 &&
      setTimeout(() => setResendCounter(resendCounter - 1), 1000);
  }, [resendCounter]);

  const onResendCode = () => {
    getSAMLNumber();
  };

  useEffect(() => {
    if (!authNumber) {
      return;
    }

    const stopTimer$ = new Subject();
    const subscription = interval(3000)
      .pipe(
        takeUntil(stopTimer$),
        takeUntil(interval(300000)),
        concatMap(async () => await samlService.isUserVerified())
      )
      .subscribe({
        next: (resp) => {
          if (resp.data?.isNafathCompleted) {
            afterVerification(resp?.data);
            subscription.unsubscribe();
            stopTimer$.next();
            stopTimer$.complete();
          }
        },
        error: (err) => {
          subscription.unsubscribe();
        },
        complete: () => {
          setStopTimer(true);
          subscription.unsubscribe();
          stopTimer$.next();
          stopTimer$.complete();
        },
      });

    return () => {
      if (stopTimer) {
        stopTimer$.next();
        stopTimer$.complete();
      }
      if (subscription) {
        subscription.unsubscribe();
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authNumber]);

  const success = () => {
    if (onSuccess) {
      setTimeout(() => {
        onSuccess();
      }, 200);
    }
  };

  const afterVerification = (response) => {
    let loginModel = response?.loginModel;
    saveTokenFromRegistration(loginModel);
    setIsSuccessNafath(true);
    success();
  };

  const getSAMLNumber = () => {
    setLoading(true);
    samlService
      .getAuthNumber(investorDetails?.nationalId)
      .then((resp) => {
        let loginModel = resp.data?.loginModel;
        saveTokenFromRegistration(loginModel, serverNowFrom(resp));
        setTimeout(() => {
          setAuthNumber(resp.data?.number);
        }, 200);
        setNafathFailure(null);
        setResendCounter(nafathResendLockSeconds(resp, counter));
        setLoading(false);
      })
      .catch((err) => {
        const failure = nafathFailureFrom(err);
        setAuthNumber(null);
        setNafathFailure(failure);
        setResendCounter(
          failure === NafathFailure.activeTransaction ? NAFATH_TRANSACTION_TIMEOUT_SECONDS : 0
        );
        setLoading(false);
      });
  };

  const onManuallyVerify = () => {
    setLoadingNafath(true);
    samlService
      .isUserVerified(true)
      .then((resp) => {
        if (resp.data) {
          setLoadingNafath(false);
          afterVerification(resp.data);
        }
      })
      .catch((err) => {
        setLoadingNafath(false);
      });
  };

  const NafathSection = () => {
    return <Box className="flex flex-col justify-center items-center reg-section-height">
      {investorDetails?.nationalId ? <Box className={`md:w-[450px] w-full flex ${isSuccessNafath ? 'p-3' : 'shadow-md p-6 '} flex-col justify-center items-center rounded-md`
      }>
        <Box className="max-w-[100px] w-[100px] h-[100px]">
          <img
            src={NafathLogo}
            alt="nafathlogo"
            className="w-full h-full"></img>
        </Box>
        {!isSuccessNafath ? <>
          <Box className="flex flex-col items-center my-4">
            <TextWrapper
              classList="sub-heading !text-center"
              text={t('samlInfoText')}
            />
            <Box className="rounded-full mt-4 text-primary relative flex justify-center items-center border w-[74px] h-[74px] font-bold text-[28px]">
              {loading ? (
                <CircularProgress className="!w-[74px] !h-[74px] !absolute" />
              ) : null}
              <span className="!absolute">
                {!loading ? (
                  <span data-testid="authNumber">{authNumber}</span>
                ) : (
                  <Skeleton
                    variant="circular"
                    className="!w-[30px] !h-[30px]"></Skeleton>
                )}
              </span>
            </Box>
            {!loading && nafathMessageKey(nafathFailure) ? (
              <TextWrapper
                classList="caption !text-sm !text-center mt-3"
                text={t(nafathMessageKey(nafathFailure))}
              />
            ) : null}
          </Box>
          <Box className="flex justify-center items-center mb-4">
            {!stopTimer ? (
              <Box className="flex justify-center items-center">
                <CircularProgress className="!h-[14px] !w-[14px]" />
                <Box className="w-[6px]"></Box>
                <Box>
                  <TextWrapper
                    classList="caption !text-sm !text-center"
                    text={t('awaitingResponse')}
                  />
                </Box>
              </Box>
            ) : (
              <Box className="flex justify-center rounded-md items-center my-[10px] p-[5px] bg-[#ff00000f]">
                <Box className="!text-center">
                  <TextWrapper
                    classList="caption !text-sm "
                    text={t('nafathNoResponse')}
                  />
                </Box>
              </Box>
            )}
          </Box>
          <Box className="flex justify-center items-center !text-[14px] mb-4">
            {resendCounter === 0 ? (
              <Box className="text-center flex justify-center items-center">
                <RestartAltOutlinedIcon
                  color="primary"
                  className="!text-[20px]"
                />
                <a
                  data-testid="resendcode"
                  onClick={() => {
                    onResendCode();
                  }}
                  className={`underline-link ${loading ? 'pointer-events-none cursor-default' : ''
                    }`}>
                  {t('resendCode')}
                </a>
              </Box>
            ) : (
              <span data-testid="sentResendcode">
                {t('resendCodeAfter')}&nbsp;{resendCounter}&nbsp;{t('seconds')}
              </span>
            )}
          </Box>
          {stopTimer ? (
            <ButtonWrapper
              loading={loadingNafath}
              largeBtn
              label={t('verify')}
              onClick={() => {
                onManuallyVerify();
              }}
            />
          ) : null}
        </> : <Box className='flex justify-center flex-col space-y-2'>
          <TextWrapper
            classList="heading !text-center"
            text={t('thankYou')}
          />
          <TextWrapper
            classList="sub-heading !text-center"
            text={t('nafathCompleted')}
          />
        </Box>}
      </Box> : <Box className='justify-center flex flex-col items-center'>
        <TextWrapper
          classList="sub-heading !text-center"
          text={t('nationalIdMissing')}
        />
      </Box>}
    </Box>;
  };

  return (
    <Box>
      {showMainSection ? <SectionWithHeading loading={loading} heading={t('checkTheNafathApp')} children={
        <NafathSection />
      } /> : <NafathSection />}
    </Box>
  );
};